import React from "react";
import { Button } from "../ui/button";
import { Check, TrendingUp, Rocket, Trophy } from "lucide-react";

const PricingSection = () => {
  const plans = [
    {
      icon: TrendingUp,
      name: "Starter Plan",
      price: "£1497",
      period: "MONTHLY",
      features: [
        "Basic marketing setup and management",
        "Lead capture and contact management",
        "Automated response system",
        "Campaign setup and optimization",
        "Basic analytics and reporting",
        "Monthly performance review"
      ],
      href: "#starter-plan",
      popular: false
    },
    {
      icon: Rocket,
      name: "Professional Plan",
      price: "£2997",
      period: "MONTHLY",
      features: [
        "Everything in Starter Plan",
        "Multi-channel marketing campaigns",
        "Advanced conversion optimization",
        "Email marketing automation",
        "Lead nurturing workflows",
        "Retargeting campaigns",
        "Monthly strategy consultation"
      ],
      href: "#professional-plan",
      popular: true
    },
    {
      icon: Trophy,
      name: "Enterprise Plan",
      price: "£4997",
      period: "MONTHLY",
      features: [
        "Everything in Professional Plan",
        "Advanced system integrations",
        "24/7 support and monitoring",
        "Custom workflow development",
        "Reputation management tools",
        "Branded mobile application",
        "Comprehensive consulting package"
      ],
      href: "#enterprise-plan",
      popular: false
    }
  ];

  const handleChoosePlan = (planName) => {
    alert(`Selecting ${planName} - this would redirect to signup/checkout`);
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Choose Your Plan
          </h2>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {plans.map((plan, index) => {
            const IconComponent = plan.icon;
            return (
              <div
                key={index}
                className={`relative bg-black border rounded-lg p-8 transition-all duration-300 transform hover:scale-105 ${
                  plan.popular
                    ? "border-yellow-400 shadow-2xl shadow-yellow-400/20"
                    : "border-gray-700 hover:border-yellow-400"
                }`}
              >
                {/* Popular Badge */}
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <span className="bg-yellow-400 text-black px-4 py-1 rounded-full text-sm font-semibold">
                      Most Popular
                    </span>
                  </div>
                )}

                {/* Plan Icon and Name */}
                <div className="text-center mb-6">
                  <div className="w-12 h-12 mx-auto mb-3 bg-yellow-400 rounded-full flex items-center justify-center">
                    <IconComponent className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{plan.name}</h3>
                </div>

                {/* Price */}
                <div className="text-center mb-6">
                  <div className="text-3xl font-bold text-white mb-1">{plan.price}</div>
                  <div className="text-gray-400 text-sm">{plan.period}</div>
                </div>

                {/* Features */}
                <div className="space-y-3 mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-start space-x-3">
                      <Check className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <Button
                  onClick={() => handleChoosePlan(plan.name)}
                  className={`w-full py-3 font-semibold transition-all duration-300 ${
                    plan.popular
                      ? "bg-yellow-400 hover:bg-yellow-500 text-black"
                      : "bg-transparent border border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black"
                  }`}
                >
                  Choose
                </Button>
              </div>
            );
          })}
        </div>

        {/* Pricing Notes */}
        <div className="text-center space-y-2">
          <p className="text-gray-400 text-sm">• Additional add-ons are available for extra fees.</p>
          <p className="text-gray-400 text-sm">• All prices include VAT.</p>
          <p className="text-gray-400 text-sm">• Implementation typically takes 1–4 weeks, depending on project scope.</p>
          <p className="text-gray-400 text-sm">• Plans are billed month-to-month and require 90 days' advance notice for cancellation.</p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;